export default __webpack_public_path__ + "static/media/device.bebca430.svg";